export const CUSTOM_FIELD_IDS = Object.freeze({
  loanPurpose: "kxBSmTobF1HNoBFrY496",
  loanType: "AWfzsE12vIzsEgy6j8Ii",
  loanAmount: "sTRJxmwKNx2ctwKiG5P0",
  propertyAddress: "YKJWbJWyd67bCcutqO6X",
  unitType: "ZlYSYHw691X4tsKHiV6k",
}); 